// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + {"12":"profiler","9777":"recorder"}[chunkId] + "." + {"12":"d47653d8e65e0138","9777":"bb19010175a729bd"}[chunkId] + ".js";
};